import { Component, Input } from "@angular/core";

@Component({
  selector: "alerts-notification-button",
  templateUrl: "./alerts-notification-button.component.html",
  styleUrls: ["./alerts-notification-button.component.scss"],
})
export class AlertsNotificationButtonComponent {
  @Input()
  numberOfErrors: number;

  constructor() {}
}
